<!-- =========================================================================================
  File Name: data.vue
  Description: Lottery Data
========================================================================================== -->

<template>
	<div id="lottery-time">

		<vx-card title="开奖数据">
			<div slot="actions">
				<vx-input-group>
					<template slot="prepend">
						<vs-button class="mr-3" color="danger" type="filled" size="small"
							@click="generateToday">生成当天开奖号码</vs-button>
						<vs-button class="mr-3" color="success" type="filled" size="small"
							@click="generateN">生成N期开奖号码</vs-button>
						<!-- <vs-button class="mr-3" color="warning" type="filled" size="small"
							@click="generateLoad">读取系统彩开奖号码</vs-button> -->
						<!-- <vs-button class="mr-10" color="primary" type="filled" size="small" @click="generateExport">导出开奖号码</vs-button> -->
					</template>
					<template slot="prepend">
						<vs-select class="w-48" v-model="shortname">
							<vs-select-item :key="index" :value="item.shortname" :text="item.name"
								v-for="(item, index) in lotteryName" />
						</vs-select>
					</template>
					<vs-input class="w-48" v-model="number" placeholder="输入期号" />
					<template slot="append">
						<div class="append-text bg-warning cursor-pointer" @click="search">
							<feather-icon icon="SearchIcon"></feather-icon>
						</div>
					</template>
				</vx-input-group>
			</div>
			<vs-table stripe :data="list" noDataText="暂无开奖数据">
				<template slot="thead">
					<vs-th width="250">彩种名称</vs-th>
					<vs-th width="400">开奖期号</vs-th>
					<vs-th width="400">开奖号码</vs-th>
					<vs-th width="350">开奖时间</vs-th>
					<vs-th width="200">状态</vs-th>
					<vs-th width="450">操作</vs-th>
				</template>

				<template slot-scope="{data}">
					<vs-tr :key="index" v-for="(item, index) in list">
						<vs-td :data="item.shortname">
							<div v-if="item.id !== -1">
								{{lotteryList[item.shortname] ? lotteryList[item.shortname].name : ''}}</div>
							<vs-select class="w-full" v-model="item.shortname" v-else>
								<vs-select-item :key="index" :value="item.shortname" :text="item.name"
									v-for="(item, index) in lotteryName" />
							</vs-select>
						</vs-td>
						<vs-td :data="item.number">
							<vs-input v-model="item.number" class="w-full" />
						</vs-td>
						<vs-td :data="item.data">
							<vs-input v-model="item.data" class="w-full" />
						</vs-td>
						<vs-td :data="item.time">{{item.date}}</vs-td>
						<vs-td :data="item.isJs">
							<span :class="item.isJs == 1 ? 'font-bold' : ''">{{item.isJs == 1 ? '已结算' : '待结算'}}</span>
						</vs-td>
						<vs-td>
							<vs-button color="primary" type="filled" size="small" @click="modify"
								:data-index="index">{{item.id === -1 ? '添加' : '更改'}}</vs-button>
							<vs-button color="success" type="filled" size="small" @click="reJs" :data-index="index"
								class="ml-2" v-if="item.id !== -1">重新结算</vs-button>
							<vs-button color="danger" type="filled" size="small" @click="del" :data-index="index"
								class="ml-2">删除</vs-button>
						</vs-td>
					</vs-tr>
				</template>
			</vs-table>

			<div class="mt-4">
				<vs-button color="warning" type="filled" size="small" @click="add">添加开奖号码</vs-button>
				<vs-button color="danger" type="filled" size="small" @click="addMulti" class="ml-4">批量添加开奖号码</vs-button>
			</div>

			<vs-pagination class="mt-6" :total="totalPage" v-model="page" goto />
		</vx-card>

		<vs-prompt vs-title="批量添加开奖数据" vs-accept-text="确认添加" vs-cancel-text="取消" :vs-active.sync="multiAddShow"
			@vs-accept="addMultiDo">
			<div class="mb-4">
				<vs-select class="w-full" label="彩种" v-model="multiAddShortname">
					<vs-select-item :key="index" :value="item.shortname" :text="item.name"
						v-for="(item, index) in lotteryName" />
				</vs-select>
			</div>
			<div>
				<vs-textarea class="w-full h-64" v-model="multiAddData" label="数据" placeholder="期号 开奖数据 (每行一条开奖数据)" />
			</div>
		</vs-prompt>

		<vs-prompt vs-title="生成数据" vs-accept-text="保存" vs-cancel-text="导出" :vs-active.sync="generateIsShow"
			@vs-accept="generateSave" @vs-cancel="generateExport" @vs-close="generateAlertHide">
			<div class="mb-4" v-if="generateShow === 'n'">
				<vs-input v-model="generateCount" type="number" class="w-full" label="生成数量" />
			</div>
			<div class="mb-4">
				<vs-select class="w-full" label="类型" v-model="generateTypeIndex">
					<vs-select-item :key="index" :value="index" :text="item"
						v-for="(item, index) in generateTypeList" />
				</vs-select>
				<!-- <vs-select class="w-full" label="彩种" v-model="multiAddShortname">
		  <vs-select-item :key="index" :value="item.shortname" :text="item.name" v-for="(item, index) in lottery" />
		</vs-select> -->
			</div>
			<div style="height: 300px; overflow-y: auto; overflow-x: hidden;">
				<vs-table stripe :data="generateList">
					<template slot="thead">
						<vs-th width="80">彩种</vs-th>
						<vs-th width="100">期号</vs-th>
						<vs-th width="80">号码</vs-th>
						<vs-th width="140">时间</vs-th>
					</template>
					<template slot-scope="{data}">
						<vs-tr :key="index" v-for="(item, index) in generateList">
							<vs-td>{{generateTypeList[generateTypeIndex]}}</vs-td>
							<vs-td>{{item.number}}</vs-td>
							<vs-td>{{item.data}}</vs-td>
							<vs-td>{{item.time.substr(10)}}</vs-td>
						</vs-tr>
					</template>
				</vs-table>
			</div>
		</vs-prompt>

	</div>
</template>

<script>
	let generateList = []

	export default {
		data() {
			return {
				page: 1,
				totalPage: 1,
				list: [],
				lottery: {},
				lotteryList: {},
				lotteryName: [{
					shortname: '',
					name: '选择彩种'
				}],
				shortname: '',
				number: '',
				multiAddShow: false,
				multiAddShortname: '',
				multiAddData: '',
				generateShow: '',
				generateIsShow: false,
				generateTypeList: [],
				generateTypeIndex: 0,
				generateCount: 1
			}
		},
		methods: {
			modify(e) {
				const dataset = e.currentTarget.dataset
				const postdata = this.list[dataset.index]
				postdata.authKey = localStorage.getItem('authKey')
				this.$utils.post('lottery-dataDo', postdata).then(res => {
					this.$vs.dialog({
						title: '提示',
						text: res,
						acceptText: '确认'
					})
					this.load()
				})
			},
			load() {
				const postdata = {}
				postdata.authKey = localStorage.getItem('authKey')
				postdata.page = this.page
				postdata.shortname = this.shortname
				postdata.number = this.number
				this.$utils.post('lottery-dataList', postdata).then(res => {
					this.list = res.list
					this.totalPage = Math.ceil(res.count / res.pagesize)
				})
			},
			del(e) {
				const index = e.currentTarget.dataset.index
				if (this.list[index].id === -1) {
					this.list.splice(index, 1)
					return
				}
				this.$vs.dialog({
					type: 'confirm',
					color: 'danger',
					title: '确认',
					text: '确认删除本条开奖数据吗?',
					acceptText: '确认',
					cancelText: '取消',
					accept: () => {
						const postdata = {}
						postdata.authKey = localStorage.getItem('authKey')
						postdata.id = this.list[index].id
						this.$utils.post('lottery-dataDelete', postdata).then(res => {
							this.$vs.dialog({
								title: '提示',
								text: res,
								acceptText: '确认'
							})
							this.load()
						})
					}
				})
			},
			add() {
				this.list.push({
					id: -1,
					shortname: ''
				})
			},
			addMulti() {
				this.multiAddShow = true
			},
			addMultiDo() {
				const postdata = {}
				postdata.authKey = localStorage.getItem('authKey')
				postdata.shortname = this.multiAddShortname
				postdata.data = this.multiAddData
				this.$utils.post('lottery-dataMultiAdd', postdata).then(res => {
					this.$vs.dialog({
						title: '提示',
						text: res,
						acceptText: '确认'
					})
					this.load()
				})
			},
			reJs(e) {
				const index = e.currentTarget.dataset.index
				this.$vs.dialog({
					type: 'confirm',
					color: 'danger',
					title: '确认',
					text: '确认重新结算本期数据吗?',
					acceptText: '确认',
					cancelText: '取消',
					accept: () => {
						const postdata = {}
						postdata.authKey = localStorage.getItem('authKey')
						postdata.id = this.list[index].id
						this.$utils.post('lottery-dataReJs', postdata).then(res => {
							this.$vs.dialog({
								title: '提示',
								text: res,
								acceptText: '确认'
							})
							this.load()
						})
					}
				})
			},
			search() {
				this.page = 1
				this.load()
			},

			generateAlertHide() {
				this.generateShow = null
			},
			generateToday() {
				this.generateShow = 'today'
				this.generateIsShow = true
				generateList = []
				for (let i = 1; i <= 1440; i++) {
					generateList.push(this.$utils.addZero(parseInt(Math.random() * 100000), 5))
				}
			},
			generateN() {
				this.generateShow = 'n'
				this.generateIsShow = true
				generateList = []
				for (let i = 1; i <= 1440; i++) {
					generateList.push(this.$utils.addZero(parseInt(Math.random() * 100000), 5))
				}
			},
			generateExport() {
				const filename = '开奖数据导出.txt'
				const contentType = 'application/octet-stream'
				const a = document.createElement('a')
				let content = '彩种名称\t\t开奖期号\t\t\t开奖号码\t\t开奖时间'
				for (let i = 0; i < this.generateList.length; i++) {
					const row = this.generateList[i]
					content +=
						`\n${this.generateTypeList[this.generateTypeIndex]}分彩\t\t${row.number}\t\t${row.data}\t\t${row.time}`
				}
				const blob = new Blob([content], {
					type: contentType
				})
				a.href = window.URL.createObjectURL(blob)
				a.download = filename
				a.click()
				a.remove()
			},
			generateSave() {
				const postdata = {}
				postdata.authKey = localStorage.getItem('authKey')
				const selectedLottery = this.generateTypeList[this.generateTypeIndex];
				const matchingLotteryData = [];
				for (const key in this.lottery) {
					if (this.lottery[key].name === selectedLottery) {
						matchingLotteryData.push(this.lottery[key]);
					}
				}
				const numLength = matchingLotteryData[0].shortname;
				postdata.shortname = numLength
				postdata.data = []
				for (let i = 0; i < this.generateList.length; i++) {
					const item = this.generateList[i]
					postdata.data.push(item.number + ' ' + item.data.split('').join(',') + ' ' + item.time)
				}
				postdata.data = postdata.data.join('\n')
				this.$utils.post('lottery-dataMultiAdd', postdata).then(res => {
					this.$vs.dialog({
						title: '提示',
						text: res,
						acceptText: '确认'
					})
					this.generateIsShow = true
				}).catch(e => {
					this.$vs.dialog({
						title: '提示',
						text: e,
						acceptText: '确认'
					})
					this.generateIsShow = true
				})
			},
			generateLoad() {
				const postdata = {}
				postdata.authKey = localStorage.getItem('authKey')
				const selectedLottery = this.generateTypeList[this.generateTypeIndex];
				const matchingLotteryData = [];
				for (const key in this.lottery) {
					if (this.lottery[key].name === selectedLottery) {
						matchingLotteryData.push(this.lottery[key]);
					}
				}
				const numLength = matchingLotteryData[0].shortname;
				postdata.shortname = numLength
				postdata.isToday = 1
				this.$utils.post('lottery-dataList', postdata).then(res => {
					generateList = res.list
					for (let i = 0; i < generateList.length; i++) generateList[i].time = generateList[i].date
					this.generateShow = 'load'
					this.generateIsShow = true
				})
			}
		},
		watch: {
			page(newValue) {
				this.page = newValue
				this.load()
			},
			generateTypeIndex() {
				if (this.generateShow === 'load') {
					this.generateShow = null
					this.generateLoad()
				}
			}
		},
		computed: {
			generateList() {
				if (this.generateShow === 'load') return generateList
				const list = []
				if (!this.generateShow) return list
				const date = new Date()
				const today = new Date(date.toLocaleDateString()).getTime() / 1000
				const now = date.getTime() / 1000
				const start = parseInt((now - today) / 60)
				const number = date.getFullYear() + this.$utils.addZero(date.getMonth() + 1, 2) + this.$utils.addZero(date
					.getDate(), 2)
				let shang, zeroCount


				const selectedLottery = this.generateTypeList[this.generateTypeIndex];

				const matchingLotteryData = [];

				for (const key in this.lottery) {
					if (this.lottery[key].name === selectedLottery) {
						matchingLotteryData.push(this.lottery[key]);
					}
				}

				const numLength = matchingLotteryData[0].num.length;
				const intervalInMinutes = matchingLotteryData[0].interval / 60;

				shang = intervalInMinutes
				zeroCount = numLength

				let count = 0
				for (let i = 1; i <= 1440; i++) {
					if (i % shang !== 0) continue
					if (this.generateShow === 'n') {
						if (i <= start) continue
						if (count >= this.generateCount) break
					}
					const d = new Date(today * 1000 + i * 60000)
					const time = d.getFullYear() + '-' + this.$utils.addZero(d.getMonth() + 1, 2) + '-' + this.$utils
						.addZero(d.getDate(), 2) + ' ' + this.$utils.addZero(d.getHours(), 2) + ':' + this.$utils.addZero(d
							.getMinutes(), 2) + ':' + this.$utils.addZero(d.getSeconds(), 2)
					const num = number + this.$utils.addZero(parseInt(i / shang), zeroCount)
					list.push({
						number: num,
						data: generateList[i - 1],
						time: time
					})
					count++
				}
				return list
			}
		},
		mounted() {
			this.load()

			this.$utils.post('lottery-lotteryAll', {
				authKey: localStorage.getItem('authKey')
			}).then(res => {
				for (let i = 0; i < res.length; i++) {
					this.lotteryList[res[i].shortname] = res[i]
					this.lotteryName.push({
						shortname: res[i].shortname,
						name: res[i].name
					})

					if (res[i].type === "ssc" && res[i].enable === "1") {
						// 将彩种信息添加到 this.lottery
						this.lottery[res[i].shortname] = res[i]
						this.generateTypeList.unshift(res[i].name);
					}
					//console.log(this.generateTypeList); 

				}


				this.$forceUpdate()
			})
		}
	}
</script>